import { cn, StatusBadge } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";
import { vars } from "../css-vars";
import { useSceneTimeline } from "../motion/use-scene-timeline";
import { AppWindow } from "./app-window";

// Atelier at the supplier's (ADR-286): Tomorrow's purchase order arrives, the lines are confirmed, one gets a new date,
// and Backstage hears it at once.
const durations = [1800, 2400, 2400, 2800] as const;
const places = ["Home", "Purchase orders", "Linesheets", "Returns"];
const lines = [
  { style: "Merino crew · Ecru", quantity: 240, date: "12 Feb" },
  { style: "Merino crew · Ink", quantity: 180, date: "12 Feb" },
  { style: "Ribbed cardigan · Moss", quantity: 120, date: "12 Feb", proposed: "19 Feb" },
  { style: "Wide knit skirt · Rust", quantity: 90, date: "12 Feb" },
];

export function AtelierScene({ active, still, dark }: { active: boolean; still: boolean; dark: boolean }) {
  const step = useSceneTimeline(durations, active, still);
  return (
    <AppWindow app="atelier" dark={dark} title="atelier.nexxt" places={places} className={`is-step-${step}`}>
      <div className="scene-pad">
        <div className="flex flex-wrap items-center gap-2">
          <p className="scene-heading">
            {m.scene_atelier_po()} · <span className="font-mono">PO-4512</span>
          </p>
          {step === 0 && <StatusBadge tone="info" label={m.scene_atelier_new()} />}
        </div>
        <div className="mock-table">
          <div className="mock-table-row is-head">
            <span>{m.scene_atelier_style()}</span>
            <span>{m.scene_atelier_quantity()}</span>
            <span>{m.scene_atelier_delivery()}</span>
            <span />
          </div>
          {lines.map((line, i) => {
            const proposing = line.proposed !== undefined && step >= 2;
            return (
              <div key={line.style} className="mock-table-row" style={vars({ "--i": i })}>
                <span>{line.style}</span>
                <span className="tabular-nums">{line.quantity}</span>
                <span className={cn("tabular-nums", proposing && "is-changed")}>
                  {proposing ? line.proposed : line.date}
                </span>
                <span className="mock-table-state">
                  {proposing ? (
                    <StatusBadge tone="warning" label={m.scene_atelier_proposed()} />
                  ) : (
                    step >= 1 && <StatusBadge tone="success" label={m.scene_atelier_confirmed()} />
                  )}
                </span>
              </div>
            );
          })}
        </div>
        <div className={cn("scene-footer", step === 3 && "is-shown")}>
          <StatusBadge tone="success" label={m.scene_atelier_sent()} />
          <span className="echo-chip" data-app="backstage">
            BACKSTAGE · {m.scene_atelier_proposed()}
          </span>
        </div>
      </div>
    </AppWindow>
  );
}
